<!-- <div class="fh5co-loader"></div> -->

	<div>
	<nav class="fh5co-nav" role="navigation" style="background-color: #5E6262;">
		<div class="container">
			<div class="row">
				<div class="col-xs-2 text-left">
					<div id="fh5co-logo">    <a [routerLink]="['/home']" class="navbar-brand mr-lg-5">
						<img src="assets/images/logo.png" style="height:50px;"> </a></div>
				</div>
				<div class="col-xs-10 text-right menu-1">
					<ul>
						<li class="active" style="color: #ffffff; font-family: '微軟正黑體';"><b>防疫時期, 企業部屬最佳選擇. 遠距視訊, 快速協作.</b></li>
						<li class="active"><a herf="#"></a><img src="assets/images/free_2.png" style="width: 13%;"></li>
					</ul>
				</div>
			</div>

		</div>
	</nav>

	<header id="fh5co-header" class="fh5co-cover" role="banner" style="height: 90vh;">
		<div class="container">
			<div class="row">
				<div class="col-md-7 text-left board">
					<div class="display-t">
						<div class="wow fadeInUp"  style="padding:10% 0%;">
							<h3 style="text-align: center; color: #45C1E5; font-weight: bold;">免費體驗</h3>
							<h5 style="text-align: center; color: #ffffff; font-weight: bold;">請填寫您的詳細資料，然後按「立即體驗」按鈕開始體驗。</h5>
							<form role="form" [formGroup]="messageForm" (ngSubmit)="onSubmit()">
                <input type="text" class="form-control form-control-alternative" id="exampleFormControlInput1"
                  placeholder="*姓名(必填)" formControlName="messagerName" name="messagerName" required="">
                <input type="email" class="form-control form-control-alternative" id="exampleFormControlInput1"
                  placeholder="*電子郵件地址(必填)" formControlName="messageEmail" name="messageEmail" required="">
                <input type="text" class="form-control form-control-alternative" id="exampleFormControlInput1"
                  placeholder="*組織名稱(必填)" formControlName="messageCompany" required="">
                <input type="text" class="form-control form-control-alternative" id="exampleFormControlInput1"
                  placeholder="*聯絡電話(必填)" formControlName="messagePhone" required="">
                <div class="text-center">
									<button type="submit" class="btn btn-default my-4" style="margin-top: 5%;" id=free [disabled]="messageForm.invalid"></button>
								</div>
							</form>
						</div>
					</div>
				</div>
			</div>
		</div>
	</header>


	<footer id="fh5co-footer" role="contentinfo" style="background-color: #2F2D2D;">
		<div class="container">
			<div class="row copyright">
				<div class="col-md-12 text-center">
					<p>
						<small class="block">地址 : 新北市中和區建八路2號4樓之7 &nbsp; &nbsp; 電話:02-8228-0407 &nbsp; &nbsp; Copyright&copy;2020 原碼數位科技</small>
					</p>
				</div>
			</div>

		</div>
	</footer>
	</div>

	<div class="gototop js-top">
		<a href="#" class="js-gotop"><i class="icon-arrow-up"></i></a>
	</div>
